export const genderOptions = [
  {
    label: 'Female',
    value: 'female'
  },
  {
    label: 'Male',
    value: 'male'
  }
];

export const ageOptions = [
  {
    label: '18-24',
    value: '18-24'
  },
  {
    label: '25-34',
    value: '25-34'
  },
  {
    label: '35-44',
    value: '35-44'
  },
  {
    label: '45-54',
    value: '45-54'
  },
  {
    label: '55-64',
    value: '55-64'
  },
  {
    label: '65+',
    value: '65+'
  }
];

export enum ProductPhysicalSelectEnum {
  ship = 'Shipping',
  video = 'ShareVideo'
}

export const getSecondText = () => [
  {
    text: `I will craft a tailored campaign brief that aligns perfectly with your brand’s objectives and resonates with your target influencers. Here’s a detailed breakdown of the process...`,
    pause: 300
  },
  {
    text: `Basic Information: Gather key elements like your business logo and name to ensure consistency across all materials and influencer collaborations.`,
    pause: 300
  },
  {
    text: `Campaign Introduction: Develop a compelling introduction that provides influencers with the background, objectives, and vision of the campaign. This sets a clear context and fosters a deeper connection with your brand’s mission.`,
    pause: 300
  },
  {
    text: `Elevator Pitch: Develop a concise, engaging pitch that effectively communicates your product or service’s unique value.`,
    pause: 300
  },
  {
    text: `Key Messaging Framework: Outline the core functions and key talking points that align with the selected concept. This ensures influencers grasp the essential features and benefits of your product or service, enabling them to create authentic and impactful content that drives optimal results.`,
    pause: 300
  },
  {
    text: `Target Audience Analysis: Define and identify the primary audiences for the campaign. Precise audience targeting guarantees that the campaign reaches the right demographic, maximizing engagement and effectiveness.`,
    pause: 300
  },
  
];